import React, { useEffect, useState } from 'react'
import { SelectChangeEvent, Typography } from '@mui/material'
import { useStyles } from './Canvas.styles'
import MyWebComponent from './west'
import { useFormikContext } from 'formik'
import { productDummyData } from '../../../utils/templateCreationConstants'
import { ColorSelectorV2 } from '@labrav/react-components'
import {
  extractColorV2,
  hexadecimalColor,
} from '../../../common/utils/productCreationUtil'
import { calculateMinMaxResult } from '../../AddEditProductFormComponents/FlyOutProductBranding/FlyOutProductBranding'
import { convertRGBAAlpha } from '../../../common/utils/convertRGBAAlpha'
import { hexToRgb, rgbToHex } from '../../../utils/colorsConvertor'
import { ListingCardInCreation } from '../../../modules/storefront/listingCardCreation/reducer'

export const Canvas: React.FC = () => {
  const { classes } = useStyles()

  const { values, setFieldValue, handleBlur, touched, errors } =
    useFormikContext<ListingCardInCreation>()
  const { listingCardData } = values

  const [canvasColorType, setCanvasColorType] = useState<string>(
    listingCardData?.template?.data?.canvasColor
      ? listingCardData?.template?.data?.canvasColor?.includes('#')
        ? 'HEX'
        : 'RGB'
      : 'HEX'
  )
  const [canvasColor, setCanvasColor] = useState<string[]>(() => {
    const colorString = listingCardData?.template?.data?.canvasColor || ''
    return extractColorV2(canvasColorType, colorString)
  })
  useEffect(() => {
    const colorString = listingCardData?.template?.data?.canvasColor || ''
    setCanvasColor(extractColorV2(canvasColorType, colorString))
  }, [listingCardData?.template?.data?.canvasColor])

  const handleColorChange = async (index: number, event: SelectChangeEvent) => {
    const updatedColorValues = calculateMinMaxResult(
      index,
      [...canvasColor],
      event.target.value as string
    )

    const color =
      canvasColorType === 'RGB'
        ? `rgba(${updatedColorValues[0]}, ${updatedColorValues[1]}, ${updatedColorValues[2]}, 100)`
        : hexadecimalColor(`${updatedColorValues[4]}`, 100)

    const field = 'listingCardData.template.data.canvasColor'
    await setFieldValue(field, color)
  }

  const handleTypeChange = async (event: SelectChangeEvent) => {
    const typeValue = event.target.value as string
    const resetValue =
      typeValue === 'RGB'
        ? hexToRgb(canvasColor[4]).toString()
        : rgbToHex(
            parseInt(canvasColor[0]),
            parseInt(canvasColor[1]),
            parseInt(canvasColor[2])
          )

    setCanvasColorType(typeValue)
    await setFieldValue('listingCardData.template.data.canvasColor', resetValue)
  }

  const isHorizontal =
    values?.listingCardData?.template?.data?.card?.customization
      ?.cardOrientation === 'horizontal'
  useEffect(() => {
    if (isHorizontal) {
      setFieldValue(
        'listingCardData.template.data.card.customization.minWidth',
        '950px'
      )
      setFieldValue(
        'listingCardData.template.data.card.customization.paddingRight',
        '24px'
      )
    } else {
      setFieldValue(
        'listingCardData.template.data.card.customization.minWidth',
        '0px'
      )
      setFieldValue(
        'listingCardData.template.data.card.customization.paddingRight',
        '0px'
      )
    }
  }, [values, isHorizontal])
  return (
    <div
      className={classes.canvas}
      data-testid="canvas"
      style={{ backgroundColor: listingCardData?.template?.data?.canvasColor }}
    >
      <div className={classes.rowContainer}>
        <div className={classes.canvasColorContainer}>
          <Typography
            className={classes.sectionTitle}
            data-testid="card-style-canvas-color-selector-title"
          >
            Canvas color
          </Typography>
          <div className={classes.colorSelectorWidth}>
            <ColorSelectorV2
              data-testid="card-style-canvas-color-selector"
              selectedField={canvasColorType}
              placeholder={listingCardData?.template?.data?.canvasColor}
              onBlur={handleBlur}
              onChange={event => handleTypeChange(event)}
              keyName={'listingCardData.template.data.canvasColor'}
              colorValues={canvasColor}
              handleColorChange={(index, event) =>
                handleColorChange(index, event)
              }
              color={convertRGBAAlpha(
                listingCardData?.template?.data?.canvasColor || '',
                false
              )}
              isError={
                !!(
                  (touched as any).listingCardData?.template?.data
                    ?.canvasColor &&
                  (errors as any).listingCardData?.template?.data?.canvasColor
                )
              }
              errorText={
                !!(touched as any).listingCardData?.template?.data
                  ?.canvasColor &&
                ((errors as any).listingCardData?.template?.data?.canvasColor ||
                  '')
              }
              secondaryVariant={true}
            />
          </div>
        </div>
      </div>
      <div className={classes.cardWrapper}>
        <MyWebComponent
          int-data={JSON.stringify(listingCardData?.template?.data)}
          product-details={JSON.stringify(productDummyData)}
        />
      </div>
    </div>
  )
}
